/**
 * Desktop sub-submenus — click to open (no hover)
 * Toggles .is-open on .header__nav-links-item.has-dropdown when its link is clicked.
 * Uses CAPTURE phase to intercept before other theme handlers.
 */
(function () {
  var initialized = false;

  function initDesktopSubmenus() {
    if (initialized) return;
    initialized = true;

    // Nav click: intercept links that open sub-submenus (capture phase)
    document.addEventListener('click', function (e) {
      // Only on desktop
      if (window.innerWidth <= 989) return;

      // Find the clicked link
      var link = e.target.closest('.header__nav-dropdown-link');
      if (!link) return;

      // Must be inside a .header__nav-links-item.has-dropdown
      var li = link.parentElement;
      if (!li) return;
      if (!li.classList.contains('header__nav-links-item')) return;
      if (!li.classList.contains('has-dropdown')) return;

      var isOpen = li.classList.contains('is-open');

      // Close all siblings
      if (li.parentElement) {
        li.parentElement.querySelectorAll('.header__nav-links-item.has-dropdown.is-open').forEach(function (sib) {
          if (sib !== li) sib.classList.remove('is-open');
        });
      }

      if (isOpen) {
        // Second click: close + navigate
        li.classList.remove('is-open');
      } else {
        // First click: open, block navigation
        e.preventDefault();
        e.stopImmediatePropagation();
        li.classList.add('is-open');
      }
    }, true); // CAPTURE phase fires first

    // Close all when clicking outside any dropdown
    document.addEventListener('click', function (e) {
      if (window.innerWidth <= 989) return;
      if (e.target.closest('.header__nav-item.dropdown')) return;
      document.querySelectorAll('.header__nav-links-item.has-dropdown.is-open').forEach(function (li) {
        li.classList.remove('is-open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initDesktopSubmenus);
  document.addEventListener('shopify:section:load', function () {
    initialized = false;
    initDesktopSubmenus();
  });
})();
